import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    FunctionariesSwitch,
    FunctionariesSwitchHistorical,
} from '../../../../../shared/types/systemConfiguration/functionariesSwitch';
import {
    asyncGetFunctionariesSwitch,
    asyncGetFunctionariesSwitchHistorical,
} from '../../../../../services/functionaries-switch.service';
import { FUNCTIONARIES_SWITCHBOARD } from '../../../../../routes/paths';

export const useFunctionariesSwitchDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idFunctionariesSwitch } = useParams();

    const [loading, setLoading] = useState(false);
    const [functionarieSwitch, setFunctionariesSwitch] =
        useState<FunctionariesSwitch>();
    const [functionarieSwitchHistorical, setFunctionariesSwitchHistorical] =
        useState<FunctionariesSwitchHistorical[]>();

    useEffect(() => {
        if (Boolean(idFunctionariesSwitch)) {
            setLoading(true);
            asyncGetFunctionariesSwitch(idFunctionariesSwitch)
                .then((product) => {
                    if (product) setFunctionariesSwitch(product);
                    else navigate(FUNCTIONARIES_SWITCHBOARD);
                })
                .finally(() => setLoading(false));
        }
    }, [idFunctionariesSwitch]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetFunctionariesSwitchHistorical(idFunctionariesSwitch)
                .then((resp) => {
                    if (resp) setFunctionariesSwitchHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        functionarieSwitch,
        functionarieSwitchHistorical,
        showHistorical,
        setShowHistorical,
    };
};
